// Copyright (c) 2017 Deere & Company

import SelectedStatuses, {getDefaultState} from '../state/selected-statuses';
import actions from '../actions-list';
import {updateKeyValueSelectionList} from '../../../shared/services/list-selections';

const resetStatuses = state =>
    SelectedStatuses.update(state, {
        $set: getDefaultState()
    });

const selectStatus = (state, action) =>
    SelectedStatuses.update(state, {
        $set: updateKeyValueSelectionList(
            action.status,
            action.isSelected,
            state
        )
    });

const selectAllStatuses = (state, action) => {

    const toggleState = state.length > 0 ? [] : action.statuses;

    return SelectedStatuses.update(state, {
        $set: toggleState
    });

};

const selectAllStatusesOnLoad = (state, action) =>
    SelectedStatuses.update(state, {
        $set: action.statuses
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES]: resetStatuses,
        [actions.SELECT_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUS]: selectStatus,
        [actions.SELECT_ALL_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES]: selectAllStatuses,
        [actions.SELECT_ALL_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES_ON_LOAD]: selectAllStatusesOnLoad
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/reducers/status-selection.js